import { create as a } from "zustand";
const s = a()((o) => ({
  name: "",
  isOpen: !1,
  isClosing: !1,
  configData: {
    name: "",
    modalRoute: "",
    options: {
      variant: "primary",
      shouldCloseOnEsc: !0
    },
    blocks: [],
    header: "",
    onCloseCallback: () => {
      console.warn("a callback fn called on close");
    }
  },
  openModal: (l) => o({ isOpen: !0, configData: l }),
  closeModal: () => o({ isOpen: !1 }),
  finishClosing: () => o({ isClosing: !1 }),
  startClosing: () => o({ isClosing: !0 })
}));
export {
  s as useModalViewStore
};
